import BaseService from "./BaseService";
import { PresetRequest, PresetResponse, PresetsResponse } from "./mappers/PresetMapper";

class PresetService extends BaseService {
  constructor() {
    super();
  }

  createPreset(data) {
    return this.post(`presets/`, PresetRequest(data))
      .then((response) => response.data)
      .then((data) => PresetResponse(data));
  }

  getPreset(id) {
    return this.get(`presets/${id}/`)
      .then((response) => response.data)
      .then((data) => PresetResponse(data));
  }

  getPresets() {
    return this.get(`presets/`)
      .then((response) => response.data)
      .then((data) => PresetsResponse(data));
  }

  updatePreset(id, data) {
    return this.patch(`presets/${id}/`, PresetRequest(data))
      .then((response) => response.data)
      .then((data) => PresetResponse(data));
  }

  deletePreset(id) {
    return this.delete(`presets/${id}/`);
  }
}

export default new PresetService();
